export const SET_ERROR = 'set-checkout-error';
const setError = ({ error }) => ({ type: SET_ERROR, payload: { error }});
export default setError;
